import { CartItemValidationIssueViewModel } from '../Item/ViewModels/CartItemValidationIssueViewModel.csharp';
import { CartViewModel } from '../ViewModels/CartViewModel.csharp';

// eslint-disable-next-line
export const handleCartResponseError = (productCode: string, response: any, cart: CartViewModel, setCart: (cart: CartViewModel) => void) => {
    const item = cart?.items?.find((x) => x.code === productCode);

    if (item && response.maxQuantity !== undefined) {
        item.maxQuantity = response.maxQuantity;
    }

    if (item && response.minQuantity !== undefined) {
        item.minQuantity = response.minQuantity;
    }

    setErrorsForItem(productCode, response.validationIssues, response.cart ?? cart, setCart);
};

const setErrorsForItem = (productCode: string, issues: CartItemValidationIssueViewModel[], cart: CartViewModel, setCart: (cart: CartViewModel) => void) => {
    const index = cart.items.findIndex((x) => x.code === productCode);
    const validationIssues = cart.items[index].validationIssues;

    const codes = validationIssues.map((x) => x.code);
    for (const issue of issues) {
        if (codes.includes(issue.code) === false) {
            validationIssues.push(issue);
        }
    }

    setCart(cart);
};
